import { Component, Input, ViewChild, Output, EventEmitter, ChangeDetectorRef, AfterViewInit, OnDestroy, ViewEncapsulation, OnInit } from '@angular/core';
import { NgForm, NgModel } from '@angular/forms';
import * as uuid from 'uuid';
import { MatSelectChange } from '@angular/material/select';
@Component({
  selector: 'sd-select-control',
  templateUrl: './select-control.component.html',
  styleUrls: ['../../assets/css/form.scss'],
  encapsulation: ViewEncapsulation.None
})

export class SelectControlComponent implements OnInit, AfterViewInit, OnDestroy {
  private initialized = false;
  private pModel: any;
  private pItems: any[] = [];
  private flag = false;
  name = uuid.v4();
  @Input() multiple = false;
  cItems: any[] = [];
  @Input() set items(items: any[]) {
    if (!Array.isArray(items)) {
      items = [];
    }
    this.pItems = items.filter(item => !!item);
    if (this.initialized) {
      this.onChanges();
    }
  }
  @Input() valueField: string;
  @Input() displayField: string;

  @Input() form: NgForm;
  @Input() label: string;

  value: string | string[];
  @Input() set model(value: any) {
    this.pModel = value || '';
    if (this.initialized) {
      this.onChanges();
    }
  }
  @Output() modelChange = new EventEmitter();
  // tslint:disable-next-line: no-output-native
  @Output() change = new EventEmitter();
  @Output() sdChange = new EventEmitter();

  // Optional
  @Input() required: boolean;
  @Input() disabled: boolean;
  @Input() validator: (value: any) => string | Promise<string>;
  @ViewChild('formModel') formModel: NgModel;
  constructor(private ref: ChangeDetectorRef) { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.form?.addControl(this.formModel);
    this.onChanges();
    this.initialized = true;
    this.ref.detectChanges();
  }

  ngOnDestroy() {
    this.form?.removeControl(this.formModel);
  }

  private onChanges = () => {
    this.cItems = this.pItems;
    this.value = this.pModel;
    if (this.flag || (!this.valueField && !this.displayField)) {
      this.cItems = this.pItems.map(e => ({
        code: e
      }));
      this.flag = true;
      this.valueField = 'code';
      this.displayField = 'code';
    } else {
      this.cItems = this.pItems;
    }
    this.formModel?.control.updateValueAndValidity({ onlySelf: false, emitEvent: true });
    if (!this.value && !this.multiple && this.required && this.cItems.length > 0) {
      setTimeout(() => {
        this.onChange(this.cItems[0][this.valueField]);
      });
    }
  }

  onSelectionChange = (change: MatSelectChange) => {
    const value = change?.value || '';
    if (this.multiple) {
      this.onChange(value || []);
    } else {
      this.onChange(value);
    }
  }

  reValidate = () => {
    this.formModel?.control.updateValueAndValidity({ onlySelf: false, emitEvent: true });
  }

  private onChange = (value: string) => {
    this.value = value;
    this.modelChange.emit(this.value);
    this.change.emit(this.value);
    this.sdChange.emit(this.value);
  }
}
